import * as React from "react";
import { Github, Linkedin, Twitter, ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
const platformLinks = [{
  label: "Strandvejen 102, Hellerup",
  href: "#"
}, {
  label: "View on Google Maps",
  href: "#"
}, {
  label: "Reservations",
  href: "#"
}, {
  label: "Private Dining",
  href: "#"
}];
const companyLinks = [{
  label: "The Menu",
  href: "/TheMenuPage"
}, {
  label: "The Kitchen",
  href: "/TheKitchenPage"
}, {
  label: "Our Story",
  href: "/NordicBitePage"
}, {
  label: "Contact",
  href: "#"
}];
const legalLinks = [{
  label: "Terms of Service",
  href: "#"
}, {
  label: "Privacy Policy",
  href: "#"
}, {
  label: "Cookie Policy",
  href: "#"
}];
const socialLinks = [{
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Github,
  href: "#",
  label: "GitHub"
}, {
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}];
export default function Footer() {
  return <footer data-section-id="161426" id="footer" className="dark bg-[#0a0a0c] text-[#fafafa] py-16 px-6 md:px-8 lg:px-12 border-t border-[#38383d]/20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col gap-6 lg:pr-8">
            <Link to="/NordicBitePage">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/pixelforge_logo.png" className="h-7 w-auto" alt="NordicBite" />
            </Link>
            <p className="text-[#b2b2b6] text-sm leading-relaxed font-sans italic">
              Crafting the future of Scandinavian gastronomy through seasonal, locally sourced ingredients and artistic precision.
            </p>
            <div className="flex items-center gap-2 mt-2">
              {socialLinks.map((social, i) => <Button key={i} variant="ghost" size="icon" asChild className="text-[#b2b2b6] hover:text-[#fafafa] hover:bg-[#9ca88a]/10" data-index={i}>
                  <Link to={social.href} aria-label={social.label}>
                    <social.icon className="size-4" />
                  </Link>
                </Button>)}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-serif text-lg tracking-normal capitalize text-[#fafafa]">
              Location
            </h3>
            <ul className="flex flex-col gap-3">
              {platformLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-[10px] uppercase tracking-[0.2em] font-mono text-[#b2b2b6] hover:text-[#9ca88a] transition-colors">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-serif text-lg tracking-normal capitalize text-[#fafafa]">
              Experience
            </h3>
            <ul className="flex flex-col gap-3">
              {companyLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-[10px] uppercase tracking-[0.2em] font-mono text-[#b2b2b6] hover:text-[#9ca88a] transition-colors">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-serif text-lg tracking-normal capitalize text-[#fafafa]">
              Legal
            </h3>
            <ul className="flex flex-col gap-3">
              {legalLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-[10px] uppercase tracking-[0.2em] font-mono text-[#b2b2b6] hover:text-[#9ca88a] transition-colors">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="bg-[#38383d]/20" />

        {}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-8 text-[10px] uppercase tracking-[0.2em] font-mono text-[#b2b2b6]">
          <p>
            &copy; {new Date().getFullYear()} NordicBite. All rights reserved.
          </p>
          <Link to="#" className="flex items-center gap-1.5 hover:text-[#fafafa] transition-colors group">
            Back to Top
            <ArrowUpRight className="size-3.5 opacity-70 group-hover:opacity-100 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
          </Link>
        </div>
      </div>
    </footer>;
}